export const formatNumber = (value: number | string | undefined | null): string | undefined => {
  if (value === null || value === undefined) return undefined;
  const parts = value.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, "\u202F");
  return parts[0];
};
